<template>
  <div class="dialog_wrap" @click="closeDialog">
    <div class="dialog_wrap_short" @click.stop="noTouch">
      <div class="dialog_wrap_close" @click="closeDialog"></div>
      <div class="dialog_wrap_content">
        <div class="wrap_content_title">邀请好友</div>
        <div class="wrap_content_desc">
          {{ url }}
        </div>
        <div class="wrap_content_btns">
          <div class="btn-ok" @click="copyUrl">复制</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
export default {
  name: 'InviteFriends',
  props: {
    isShow: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters(['isMobile','shareUrl','userInfo'])
  },
  data () {
    return {
      url: ''
    }
  },
  mounted () {
    document.getElementsByTagName('body')[0].classList.add('noscroll');
  },
  beforeDestroy () {
    document.getElementsByTagName('body')[0].classList.remove('noscroll');
  },
  created () {
    if (this.userInfo.token !== '') {
      this.url = this.shareUrl + '?fromuid=' + this.userInfo.user_id
    } else {
      this.isShowActLogin = true
    }
  },
  methods: {
    noTouch () {

    },
    closeDialog () {
      if (this.$route.name === 'reservation') {
        this.$emit('onClose', true)
      } else {
        this.$router.push({ name: 'reservation', query: this.$route.query })
      }
    },
    copyUrl () {
      let that = this
      if (this.userInfo.token !== '') {
        let url = this.shareUrl + '?fromuid=' + this.userInfo.user_id
        this.$copyText(url).then(function (e) {
          that.showSuccess('复制成功');
        }, function (e) {
          that.showError('复制失败');
        })
      } else {
        this.isShowActLogin = true
      }
    },
  }
}
</script>

<style lang="scss">

</style>
